export const exchangeRoutes = [
  {
    path: "/exchange",
    name: "Exchange",
    component: () => import("@/views/Exchange/ExchangeForm.vue"),
  },
  {
    path: "/exchange/choose-coin",
    name: "ExchangeChooseCoin",
    component: () => import("@/views/Exchange/ChooseCoin.vue"),
    meta: { back: { to: "Exchange", query: ["from", "to"] } },
  },
  {
    path: "/exchange/success",
    name: "ExchangeSuccess",
    component: () => import("@/views/Exchange/Success.vue"),
    meta: { noBack: true, transparentHeader: true },
  },
];
